import { render } from "./Share.vue?vue&type=template&id=8a59aa3c&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=8a59aa3c&lang=css"
import "./Share.vue?vue&type=style&index=1&id=8a59aa3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a59aa3c"]])

export default __exports__